/**
 * PlaybackEngine - Converts visual marks back to sound
 * Simple tone generation based on color and size
 */

// Map colors to musical notes (frequencies in Hz)
const COLOR_TO_FREQUENCY: Record<string, number> = {
  '#FF6B9D': 261.63, // C (warm pink)
  '#FFA07A': 293.66, // D (coral)
  '#FFD700': 329.63, // E (gold)
  '#7FFFD4': 392.00, // G (aquamarine)
  '#9370DB': 440.00  // A (purple)
};

export async function playSound(color: string, size: number): Promise<void> {
  return new Promise((resolve) => {
    try {
      const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();

      // Get frequency for this color
      const frequency = COLOR_TO_FREQUENCY[color] || 440;

      // Configure oscillator
      oscillator.type = 'sine'; // Soft, pleasant tone
      oscillator.frequency.setValueAtTime(frequency, audioContext.currentTime);

      // Configure volume based on size
      const volume = Math.min(size / 100, 0.3); // Gentle volume
      gainNode.gain.setValueAtTime(volume, audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(
        0.01,
        audioContext.currentTime + 0.3
      );

      // Connect and play
      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);

      oscillator.start(audioContext.currentTime);
      oscillator.stop(audioContext.currentTime + 0.3);

      oscillator.onended = () => {
        audioContext.close();
        resolve();
      };
    } catch (error) {
      console.error('Playback error:', error);
      resolve();
    }
  });
}
